import React from 'react';
import { ChecklistButtonStateText, ChecklistCompletionStatus } from 'types/enrollmentService';
import { ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types/general';
import { STEP_CARD_TEST_IDS } from '../constants';
import { CardStyled, TitleStyled, TextStyled, RightSectionStyled } from './styles';
import StepActionButton from './StepActionButton';
import StepCompletionStatus from './StepCompletionStatus';

export interface StepCardProps extends ITestingElement {
  title: string;
  text: string;
  buttonState: ChecklistButtonStateText;
  completionStatus: ChecklistCompletionStatus;
  onActionClick: () => void;
  /**
   * When true, renders the files-step card view (green left border).
   * Pass from parent based on card type (e.g. isEnrollmentFilesStep(card)).
   */
  isFilesStep?: boolean;
}

const StepCard: React.FC<StepCardProps> = ({
  title,
  text,
  buttonState,
  completionStatus,
  onActionClick,
  'data-test-id': dataTestId,
  isFilesStep = false,
}) => {
  return (
    <CardStyled data-test-id={dataTestId} $isFilesStep={isFilesStep}>
      <div>
        <TitleStyled data-test-id={STEP_CARD_TEST_IDS.TITLE}>{title}</TitleStyled>
        <TextStyled data-test-id={STEP_CARD_TEST_IDS.TEXT}>{text}</TextStyled>
      </div>
      <RightSectionStyled>
        <StepActionButton type={buttonState} onClick={onActionClick} />
        <StepCompletionStatus status={completionStatus} />
      </RightSectionStyled>
    </CardStyled>
  );
};

export default StepCard;
